export type SearchEntities = "partner_user";

export interface MentionSuggestion {
  disabled?: boolean;
  tooltip?: string;
  entity_identifier: string;
  entity_name: SearchEntities;
  icon: React.ReactNode;
  id: string;
  subTitle?: string;
  title: string;
  hideAvatar?: boolean;
}

export interface TMentionSection {
  key: string;
  title?: string;
  items: MentionSuggestion[];
}

export type MentionComponentProps = Pick<
  MentionSuggestion,
  "entity_identifier" | "entity_name"
> & {
  isEditable?: boolean;
};

export interface MentionHandler {
  getMentionedEntityDetails?: (
    entity_identifier: string
  ) => { display_name: string } | undefined;
  renderComponent: (props: MentionComponentProps) => React.ReactNode;
  searchCallback?: (query: string) => Promise<TMentionSection[]>;
}

export enum MentionComponentAttributeNames {
  ID = "id",
  EntityIdentifier = "entity_identifier",
  EntityName = "entity_name",
  Title = "title"
}

export interface TMentionComponentAttributes {
  [MentionComponentAttributeNames.ID]: string | null;
  [MentionComponentAttributeNames.EntityIdentifier]: string | null;
  [MentionComponentAttributeNames.EntityName]: SearchEntities | null;
  [MentionComponentAttributeNames.Title]: string | null;
}
